import React from 'react';

import Box from '@quintoandar/cozy-core/Box';
import Gallery from 'containers/PhotosManager';
import PropTypes from 'prop-types';

import Header from './header';

export const Photosphere = ({ params, additionalProps }) => (
  <Box>
    <Header />
    <Gallery params={params} additionalProps={additionalProps} galleryType={'photosphere'} />
  </Box>
);


Photosphere.propTypes = {
  params: PropTypes.shape({
    house_type: PropTypes.string,
    house_id: PropTypes.string,
    gallery_type: PropTypes.string,
  }),
  additionalProps: PropTypes.shape({
    photoSessionId: PropTypes.number,
    houseId: PropTypes.number,
    houseType: PropTypes.string,
  }),
};


export default Photosphere;
